import { CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { useWebStoreContext } from "contexts";
import { useState } from "react";
import { useContributeLPMutation } from "redux/apis";

const SetAddLoyaltyPointsDialog = () => {
	const [open, setOpen] = useState(false);
	const { userTracker } = useWebStoreContext();
	const [loading, setLoading] = useState(false);
	const [fieldValue, setFieldValue] = useState(0);
	const [contributeLP] = useContributeLPMutation();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFieldValue(e.target.valueAsNumber);
	};

	const handleSetLoyaltyPoints = async () => {
		if (fieldValue < 1) {
			return;
		}
		setLoading(true);
		await contributeLP({
			userId: userTracker?.id ?? "",
			loyaltyPoints: fieldValue
		}).unwrap();
		setOpen(false);
		setFieldValue(0);
		setLoading(false);
	};

	return (
		<div>
			<Button variant="outlined" onClick={handleClickOpen}>
				Add
			</Button>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>Add Loyalty Points</DialogTitle>
				<DialogContent>
					<TextField
						onChange={onChange}
						autoFocus
						margin="dense"
						id="name"
						value={fieldValue}
						label="Loyalty Points"
						type="number"
						fullWidth
						variant="standard"
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Cancel</Button>
					<Button onClick={handleSetLoyaltyPoints}>
						{loading ? <CircularProgress size={16} /> : "Set"}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default SetAddLoyaltyPointsDialog;
